/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const tgButtonsSchema = z.object({
	id: z.uuid(),
	button_name: z.string().max(50),
	button_image: z.string().nullable(),
	timeout: z.int().min(-2147483648).max(2147483647).optional(),
});
